import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function TemperatureForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [temperature, setTemperature] = useState("");
  const [notes, setNotes] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!temperature) return;

    onAdd({
      date: new Date(date).toISOString(),
      temperature: temperature,
      notes: notes || "",
      type: "temperature"
    });

    setDate(toDatetimeLocal());
    setTemperature("");
    setNotes("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2 mb-2">
        <div className="col-md-4">
          <label className="form-label">Date & Time</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="row g-2">
        <div className="col-md-4">
          <label className="form-label">Temperature (°F)</label>
          <input
            type="number"
            className="form-control"
            placeholder="e.g. 98.6"
            value={temperature}
            onChange={(e) => setTemperature(e.target.value)}
            step="0.1"
            min="90"
            max="110"
            required
          />
        </div>
        <div className="col-md-5">
          <label className="form-label">Notes</label>
          <input
            type="text"
            className="form-control"
            placeholder="Symptoms, context, etc."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button type="submit" className="btn btn-warning w-100">
            Log Temperature
          </button>
        </div>
      </div>
    </form>
  );
}
